import {
  type TrackEventInput,
  type TrackEventContext,
  type CreateEventRequest,
} from '@cibli/shared';

import { addEntry } from '@/lib/session-buffer';
import { createEvent } from '@/services/analytics';

/**
 * Fonction principale pour tracker un événement
 * Fait un double tracking : notre système interne + Plausible
 * @param params - L'événement et ses props (discriminated union)
 * @param context - Le contexte (eventSessionId, platformType, userId, boothId)
 */
export async function trackEvent(
  params: TrackEventInput,
  context: TrackEventContext,
): Promise<void> {
  const { event, props } = params;
  const { eventSessionId, platformType, userId, boothId } = context;

  addEntry({
    type: 'analytics',
    category: event,
    data: { eventSessionId, platformType, userId, boothId, props },
  });

  // Ne pas tracker si l'EventSession n'est pas prête (pour notre système)
  if (!eventSessionId) {
    console.warn('EventSession not ready, skipping event:', event);
    return;
  }

  try {
    await createEvent({
      name: event,
      eventSessionId,
      platformType: platformType || undefined,
      userId: userId || undefined,
      boothId: boothId || undefined,
      data: props,
    } as CreateEventRequest);
  } catch (error) {
    console.error('Failed to track event in internal system:', error);
  }
}
